/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2023, Zumper
 */

import type { Listable, Pin } from '@zcode/state-type'

export const bedsBathsRangeTxt = (t: Listable | Pin): (Listable | Pin)['bedsBathsRangeTxt'] => {
  let beds:
      | 'Rooms'
      | 'Rooms - Studio'
      | 'Rooms - 1 bed'
      | `Rooms - ${number} beds`
      | 'Studio'
      | 'Studio - Studio' // not actually possible
      | 'Studio - 1 bed'
      | `Studio - ${number} beds`
      | '1 bed'
      | `${number} - Studio` // not actually possible
      | `${number} - 1 bed` // not actually possible
      | `${number} - ${number} beds`
      | `${number} beds`,
    baths: '1 bath' | `${number} baths` | `${number} - ${number} bath${'' | 's'}`
  if (t.maxBedrooms === -1) {
    beds = 'Rooms'
  } else {
    const max =
      t.maxBedrooms === 0
        ? 'Studio'
        : t.maxBedrooms === 1
          ? '1 bed'
          : (`${t.maxBedrooms} beds` as const)
    if (t.minBedrooms === -1) {
      beds = `Rooms - ${max}`
    } else if (t.minBedrooms !== t.maxBedrooms) {
      const min = t.minBedrooms === 0 ? 'Studio' : t.minBedrooms
      beds = `${min} - ${max}`
    } else {
      beds = max
    }
  }
  const maxBaths = t.maxBathrooms === 1 ? '1 bath' : (`${t.maxBathrooms} baths` as const)
  if (t.maxBathrooms === t.minBathrooms) {
    baths = maxBaths
  } else {
    baths = `${t.minBathrooms} - ${maxBaths}`
  }
  return `${beds} \u00B7 ${baths}` as const
}
